import axios from '@/plugins/axios'

export function getCommentListByQuery(token, query) {
    return axios({
        url: 'comments',
        method: 'GET',
        headers: {
            Authorization: token,
        },
        params: {
            ...query
        }
    })
}

/**
 * 根据 QQ 邮箱获取头像
 * @param {string} email QQ 邮箱
 */
export function getQQInfoByEmail(email) {
    return axios({
        url: 'qqInfo',
        method: 'get',
        params: {email}
    })
}


export function submitComment(token, form) {
    return axios({
        url: 'comment',
        method: 'POST',
        headers: {
            Authorization: token,
        },
        data: {
            ...form
        }
    })
}